// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__7kWf1","active":"NavigationItem_active__195V4"};